const SERVER =
  window.location.host === 'localhost:3000'
    ? 'http://127.0.0.1:8000'
    : 'https://mariage-il.com';

export const SERVER_URL = `${SERVER}/api/v1/`;
